import React from "react";

type CGMJourneyStepperProps = {
  labels: string[];
  currentIndex: number;
  className?: string;
};

const CGMJourneyStepper: React.FC<CGMJourneyStepperProps> = ({
  labels,
  currentIndex,
  className,
}) => {
  const safeIndex = Math.max(0, Math.min(currentIndex, labels.length - 1));
  const currentLabel = labels[safeIndex] ?? "";
  const nextLabel = labels[safeIndex + 1] ?? "";

  return (
    <div className={className}>
      <div className="flex items-center gap-2">
        {labels.map((_, idx) => {
          const isFilled = idx <= safeIndex;
          return (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={idx}
              className={`h-1 flex-1 rounded-full ${
                isFilled ? "bg-[#2F3AA6]" : "bg-[#E7E8F3]"
              }`}
            />
          );
        })}
      </div>

      <div className="mt-3 flex items-center gap-6">
        <span className="text-xs font-semibold text-[#1F2A37] truncate">
          {currentLabel}
        </span>
        {nextLabel ? (
          <span className="text-xs font-medium text-[#9CA3AF] truncate">
            {nextLabel}
          </span>
        ) : (
          <span className="text-xs font-medium text-[#9CA3AF] truncate" />
        )}
      </div>
    </div>
  );
};

export default CGMJourneyStepper;
